module.exports = __webpack_public_path__ + "img/cashback.2da0c12b.svg";